var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSortUp = function SvgSortUp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1966 9.25717L5.80331 9.25717C5.22383 9.25717 4.86277 9.79659 5.15476 10.2261L7.35142 13.4575C7.64115 13.8837 8.35879 13.8837 8.64852 13.4575L10.8452 10.2261C11.1372 9.79659 10.7761 9.25717 10.1966 9.25717Z",
    fill: "#C3CAD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80274 6.74364L10.1961 6.74364C10.7755 6.74364 11.1366 6.20422 10.8446 5.7747L8.64796 2.54329C8.35823 2.11708 7.64058 2.11708 7.35085 2.54329L5.15419 5.7747C4.86221 6.20422 5.22326 6.74364 5.80274 6.74364Z",
    fill: "#18191B"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSortUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sort-up.9aae2d6351237011833600a3b68c2b86.svg";